module.exports = __webpack_public_path__ + "img/electronic_electric_enabled.0e319cdd.svg";